export const zh = {
  racing: '赛事',
  sport: '体育',
  'home.horsesheading': '赛马',
  'home.greyhoundsheading': '赛狗',
  'home.harnessheading': '赛马车',
  'home.haveAPunt': '查看比赛数据卡',
  'generic.privacyPolicy': '隐私政策',
  'generic.refresh': '刷新',
  'generic.stake': '注金“',
  'generic.password:': '密码',
  'generic.home': '首页',
  'generic.hello': '您好',
  'generic.racing': '赛事',
  'generic.sport': '体育',
  'generic.all': '所有板球',
  'generic.termsconditions': '使用条款',
  'generic.promoPolicyTandC': '促销活动条件',
  'generic.responsiblegambling': '负责任博彩',
  'generic.responsiblegamblingtools': '负责任的博彩工具',
  'generic.logout': '登出',
  'generic.runners': '个参赛者',
  'generic.email': '邮件',
  'generic.startingPriceAcronym': 'SP',
  'sidenav.responsible': '负责任博彩',
  'sideNav.promotions': '促销活动',
  'sidenav.home': '首页',
  'sidenav.deposit': '存入资金',
  'sidenav.contactus': '联系我们',
  'sidenav.viewall': '查看全部',
  'sidenav.myaccount': '我的账户',
  'sidenav.sportaz': '体育',
  'sidenav.sports': '体育',
  'betslip.betslipmodal.totalstake': '总注额:',
  'legal.responsible.tagline4': '您今天准备输掉多少？请设置一个存款限额。',
  'legal.responsible.caption':
    '如需免费的保密支持，请致电 1800 858 858 或访问 <cta>gamblinghelponline.org.au</cta>',
  'maintenance.heading': 'maintenance.heading translation to go here',
  'maintenance.error': '我们目前正在对网站进行维护。',
  'onboarding.locationnotallowed.header': '龙在九天之外。',
  'onboarding.locationnotallowed.subheader':
    '您似乎正在从澳大利亚境外访问 {themeName}。',
  'onboarding.step2.titleInputLabel': '称谓',
  'onboarding.locationnotallowed.bodycopy': `{themeName} 仅面向澳大利亚客户提供服务。如果您身在澳大利亚，但认为错误地看到了此页面，请通过 service@goldenbet888.com.au 联系我们。`,
  'onboarding.locationnotallowed.registration': `{themeName} 是一家经澳大利亚维多利亚州博彩与赌场管理委员会注册的博彩公司，同时也是维多利亚州博彩业协会的成员。`,
  'error.heading': `身陷龙潭之中。`,
  'error.description': `<bold>我们对此深表歉意。已有工作人员正在处理此问题。</bold>`,
  'onboarding.register.createAccount': '创建账户',
  'account.overview': '概览',
  'account.sidenav.mybets': '我的投注',
  'account.sidenav.deposit': '存款',
  'account.sidenav.withdraw': '提款',
  'account.sidenav.limit': '存款限额',
  'account.sidenav.transactions': '交易',
  'account.sidenav.account': '账户',
  'account.sidenav.settings': '设置',
  'account.overview.email': '邮箱地址',
  'account.overview.firstName': '名',
  'account.overview.middleName': '中间名',
  'account.overview.lastName': '姓',
  'account.overview.mobile': '手机',
  'account.overview.residentialAddress': '居住地址',
  'account.overview.deposit': '存款',
  'account.overview.accountnumber': '账号: ',
  'account.mybets.pagetitle': '| 我的投注',
  'account.transactions.type.deposit': '存款',
  'account.privacy.otherlinks.responsiblegambling': '负责任博彩',
  'account.terms.otherlinks.responsiblegambling': '负责任博彩',
  'account.bonusbets.pagetitle': '礼金投注',
  'onboarding.step2.addressinputmanualentry': '看不到您的地址？请手动输入',
  'onboarding.step2.dobinputlabel': '出生日期',
  'onboarding.step1.ageacknowledgement':
    'I acknowledge that I am over 18 and have read, understood and agree to be bound by the',
  'onboarding.step1.promotionacknowledgement':
    'I agree to receive promotional material from {getThemeName} via email, phone and other means',
  'onboarding.step1.login': '已有账户？',
  'onboarding.step1.logincta': '登录',
  'account.depositlimit.setlimit.subheading':
    '存款限额能帮助您设定预算，并且控制可以从个人资金中用于投注的金额。',
  'onboarding.depositLimit.completeSignup': '继续',
  'onboarding.step1.emailinputempty': '需要电子邮箱地址',
  'onboarding.step1.button': '立即加入',
  'onboarding.forgotpassword.loginCta': '返回登录页面',
  'onboarding.forgotpassword.button': '发送重置链接',
  'onboarding.forgotpassword.successtext':
    '我们已向 user@gmail.com.au 发送了重置链接',
  'helpcentre.promotions.promotions': '促销活动',
  'sideNav.quickLinks': '快速链接',
  'betslip.betslipmodal.types.single': '单注',
  'betslip.betslipmodal.mybets': '我的投注',
  'account.overview.myAccount': '进行中',
  'qam.nav.accountOverview': '账户概览',
  'qam.nav.support': '支持',
  'qam.nav.myBets': '我的投注',
  'qam.nav.logOut': '登出',
  'qam.balances.bonus': '礼金投注',
  'racing.racedetails.eventrules.twoplacedividends': '前两名分红',
  'account.mybetscard.won': '恭喜成功',
  'account.mybetscard.lost': '本次未中',
  'racing.generic.win': '奖金',
  'racing.featured.moreRaces': '更多赛事',
  'racing.featured.race': '精选赛事',
  'racing.exotics.totalstake': '总注额',
  'racing.racedetails.runnerheading': '参赛者',
  'racing.racedetails.fixedheading': '固定',
  'racing.raceDetails.winSPHeading': '获胜 SP',
  'racing.raceDetails.placeSPHeading': '排名 SP',
  'racing.errorMessages.noRacesAvailable': '当前没有可用的竞速',
  'racing.errorMessages.noRacesAvailableSubtext':
    '请考虑选择其他日期再试一次。',
  'racing.raceRunnerItem.deductions': '扣除',
  'racing.raceDetails.track': '赛道：',
  'racing.raceDetails.weather': '天气：',
  'racing.raceDetails.distance': '距离：',
  'racing.generic.flucs': '波动',
  'racing.generic.insights': '分析',
  'racing.generic.tote': 'TOTE',
  'racing.raceDetails.toteWinHeading': '获胜 MD',
  'racing.raceDetails.totePlaceHeading': '排名 MD',
  'racing.mysteryBet.rollover': '滚入',
  'racing.mysteryBet.viewInMyBets': '在我的投注中查看',
  'betSlip.potentialReturns': '预计回报:',
  'betslip.betslipmodal.types.multi': '过关投注',
  'betslip.betslipbetcard.multis.multiaddmorecta':
    '要构建过关投注，请添加更多选项以增加您的潜在回报。',
  'footer.copyright': '版权所有 © {themeName}',
  'footer.ourpartners': '我们的合作伙伴',
  'footer.weaccept': '我们接受',
  'footer.quicklinks': '快速链接',
  'account.settings.terms': '使用条款',
  'account.settings.privacy': '隐私政策',
  'header.betslipBtn.desc': '投注单',
  'contactus.title': '帮助与支持',
  'betSlip.estPayout': '预计返还:',
  'betslip.betslipmodal.placebets': '投注',
  'betslip.betslipmodal.types.srmulti': '同场过关投注',
  'betSlip.betSlipModal.srmHeader': '{legCount} Leg <span>同场过关投注</span>',
  'account.transactions.srmTransactionTitle':
    '{hasOdds, select, true {{legCount} Leg 同场过关投注 @{odds}} other {{legCount} Leg 同场过关投注}}',
  'footer.subheading': '必须年满 18 岁',
  'contactus.phoneinternational': '(国际)',
  'generic.winplace': '取胜/名次',
  'betslip.betslipbetcard.combos': '组合',
  'betslip.betslipmodal.boxed': '合票',
  'mysteryBet.rolledOver': '已滚入',
  'mysteryBet.viewInMyBets': '在我的投注中查看',
  'generic.sortBy': '排序方式',
  'generic.sortBy.time': '时间',
  'generic.upcoming': '近期赛事',
  'generic.sportAZ': '运动A-Z',
  'generic.sortBy.sport': '体育项目',
  'generic.showmore': '查看更多',
  'account.overview.title': '称谓',
  'account.deposit.depositMatchPromoBannerHeader': '您有一笔存款匹配礼金可用！',
  'account.deposit.confirmation.completemessage':
    '% 澳元的存款已成功添加到您的账户。',
  'account.overview.pendingWithdrawals': '待处理提款',
  'account.overview.pendingBets': '待处理投注',
  'account.deposit.depositMatchPromoBannerText':
    '我们将为您的下一笔最高 50 澳元存款提供额外 50% 用于投注的匹配礼金。最高 25 澳元的礼金投注额！',
  'account.deposit.depositMatch.activate': '立即激活',
  'account.deposit.labels.selectdeposit': '信用卡/借记卡存款',
  'account.deposit.labels.amount': '金额',
  'account.deposit.labels.minimumdepositamount': '最低存款金额为 10 澳元',
  'account.deposit.buttons.addcardanddeposit': '立即添加银行卡并存款',
  'generic.close': '关闭',
  'account.deposit.confirmation.complete': '存款完成',
  'betslip.betslipmodal.emptybetslipsubheading':
    '您的投注单为空。如果要开始，请添加您的竞速和体育选项。',
  'betslip.betslipmodal.emptybetslipheading':
    '就像一块幸运饼干，其中的信息静待您来揭示。',
  'account.takeabreak.importantdetailslogindesc':
    '休息结束后，您立即就可以重新登录您的账户。',
  'account.takeabreak.importantdetailsemailtitle': '1. 电子邮件和提醒',
  'account.takeabreak.importantdetailslogintitle': '2. 登录',
  'account.lifetimeexclusion.importantdetailsalertsdesc':
    '您将不再收到 {themeName} 发送的电子邮件和其他提醒。这些将在您的休息确认开始后 24 小时内终止。',
  'account.lifetimeexclusion.importantdetailstitle': '重要详细信息',
  'account.lifetimeexclusion.confirm': '按下“继续”，即表示我理解：',
  'legal.responsible.section.takeaction.lifeexclusion.button': '无期限自我禁止',
  'account.lifetimeexclusion.importantdetailsbalancedesc':
    '您 {themeName} 账户中的任何资金将自动转入您最后一次使用的提款方式。如果您之前从未提款或希望将这些资金提取到其他账户，请致电 1800 888 888 联系客户服务。',
  'account.lifetimeexclusion.importantdetailsbalancetitle':
    '1. {themeName} 余额',
  'account.takeabreak.importantdetailstitle': '重要详细信息',
  'account.lifetimeexclusion.confirmstepfunds':
    '我 {themeName} 账户中的所有资金将转入我最后一次使用的付款方式',
  'account.takeabreak.information':
    '您可以选择短暂休息 1 至 30 天，给自己一些远离投注的时间。您的休息将在确认后立即开始。',
  'account.takeabreak.pagetitle': '休息一下',
  'account.lifetimeexclusion.confirmlifetimeexclusion': '确认无期限自我禁止',
  'account.lifetimeexclusion.informationtext3':
    '如果您决定长期不投注，我们提供无期限自我禁止选项。无期限自我禁止是永久性的，无法撤销。您的所有 {themeName} 账户将被永久关闭。您将来也不能开设新账户。您的禁止将在确认后立即开始。继续操作后，您将无法再使用 {themeName} 投注或在 {themeName} 开设有效账户。',
  'account.lifetimeexclusion.information':
    '无期限自我禁止 如果您正在考虑限制投注 您可以选择短暂休息 (1 天至 30 天) 或长期休息 (6 个月至 5 年）。"',
  'account.closeaccount.currentpassword': '当前密码',
  'account.closeaccount.confirmpendingbets':
    '任何未决投注将保持有效，任何未决提款将得到处理。',
  'account.closeaccount.confirmpendingbalance':
    'Any balance that remains in your account can be withdrawn by contacting our Customer Service team at ',
  'account.closeaccount.confirmopenaccounts':
    'You agree not to open any further accounts while your account is closed. You may re-open your account at any time by contacting our Customer Service team at ',
  'account.closeaccount.text2':
    '如果您只想更改营销偏好（包括取消订阅），请点击此处。',
  'account.deposit.depositMatchOpt':
    '须遵守促销条款与细则。此优惠相关的存款需达到 $1.50 的流水要求',
  'account.closeaccount.text1': '您可以在此页面关闭您的账户',
  'account.closeaccount.enterpassword': '输入您的密码…',
  'legal.responsible.section.takeaction.deactivate.one': '关闭您的账户',
  'generic.gamblingvic': '澳大利亚维多利亚州博彩与赌场管理委员会',
  'legal.responsible.titles.getintouch': '联系我们',
  'legal.responsible.section.findoutmore.three':
    '通过电话、面对面或在线与 Gambler’s Help 友好的工作人员聊天。这类聊天免费、保密、专业并且提供全天候服务。',
  'legal.responsible.section.findoutmore.two': '不确定您的博彩习惯？',
  'legal.responsible.subheading':
    '我们致力于保护和帮助我们的客户控制他们的博彩行为。我们提供多种支持选项以满足不同需求。',
  'legal.responsible.section.findoutmore.one': `与 Gambler's Help 的专业人员聊天`,
  'legal.responsible.heading': '负责任博彩',
  'account.currentlimit.limitperioduntil': '设置限额时长',
  'account.transactions.activitystatements.pagetitle': '活动对账单',
  'account.transactions.bonusbets.pagetitle': '礼金投注',
  'account.transactions.activitystatements.title': '月度活动对账单',
  'account.transactions.activitystatements.heading':
    '快速显示您的所有投注、余额和结果总计。',
  'account.transactions.activitystatements.description':
    '每当发生交易时，您的账户活动对账单将每月通过电子邮件发送给您。',
  'account.transactions.tableheadings.7': '余额',
  'Fixed Win': '固定赢',
  'sports.allsports': '所有板球',
  'raceType.Thoroughbreds': '赛马',
  'raceType.Greyhounds': '赛狗',
  'raceType.Harness': '赛马车',
  'racing.tabbar.yesterday': '昨天',
  'racing.tabbar.nexttojump': '下一场比赛',
  'racing.tabbar.today': '今天',
  'racing.tabbar.tomorrow': '明天',
  'racing.tabbar.Monday': '星期一',
  'racing.tabbar.Tuesday': '星期二',
  'racing.tabbar.Wednesday': '星期三',
  'racing.tabbar.Thursday': '星期四',
  'racing.tabbar.Friday': '星期五',
  'racing.tabbar.Saturday': '星期六',
  'racing.tabbar.Sunday': '星期日',
  'filters.location.ausnz': 'Aus/NZ',
  'filters.location.intl': "Int'l",
  'racing.raceDetails.winHeading': '获胜',
  'racing.raceDetails.winHeadingFO': '获胜 FO',
  'racing.raceDetails.placeHeading': '排名',
  'racing.raceDetails.placeHeadingFO': '排名 FO',
  'racing.raceDetails.bestToteWinHeading': '获胜 BT',
  'racing.raceRunnerItem.runnerName':
    '{isHarnessRacing, select, true {{number}. {displayName}} other {{number}. {displayName} <span>({barrierNumber})</span>}}',
  'legal.responsible.tagline6': 'What are you really gambling with?',
  'generic.bestToteAcronym': 'BT',
  'generic.toteAcronym': 'MD',
  'generic.open': 'Open',
  'generic.recent': 'Recent',
  'generic.fav': 'Fav',
  'generic.show': '显示',
  'generic.hide': '隐藏',
  'racing.raceRunnerItem.scratchedInfo':
    '{hasScratchTime, select, true {Scratched <time>{scratchTime, time, ::dd/MM/yy, H:mm}</time>} other {Scratched}}',
  'legal.responsible.tagline2':
    'Think. Is this a bet you really want to place?',
  'betslip.betslipbetcard.stakeprefix': '$',
  'generic.fixedWin': '固定赢',
  'generic.mysteryBet': '神秘赌注',
  'generic.fixedPlace': '固定地点',
  'generic.winSP': '赢 - SP',
  'generic.placeSP': '地方 - SP',
  'generic.winTote': 'TOTE 赢',
  'generic.placeTote': 'TOTE 地方',
  'generic.mystery': '神秘',
  'racing.generic.numberRunner': 'No. / Runner',
  'footer.enquiries': 'For any enquiries email us at <link>{email}</link>',
  'footer.footerparagraph':
    "{themeName} gambling operations are governed by our <rglink>Responsible Gambling Code of Conduct</rglink>. Think! About your choices. Call Gambler's Help or Gambling Help on <telLink>1800 858 858</telLink> or visit <link>gamblershelp.com.au</link> or <link>gamblinghelponline.org.au</link>. Call Gambler's Help Youthline on <telLink>1800 262 376</telLink>. Gamble Responsibly.",
  'footer.footerbottomtext':
    'In relation to South Australian residents, our gambling operations are also governed by the South Australian Responsible Gambling <link>Code of Practice</link>. Think of the people who need your support. Gamble Responsibly.',
  'footer.betStop':
    'BetStop - the National Self-Exclusion Register is a free service for people who want to exclude from all Australian online wagering providers. For more info visit <cta>www.betstop.gov.au</cta>',
  'footer.licensedandregulated': '',
  'account.overview.balance': '余额',
  'account.overview.bonusBets': '礼金投注',
  'account.deposit.titles.main': 'Make A Deposit',
  'account.overview.withdrawable': 'Withdrawable',
  'account.overview.details': '详细',
  'account.overview.dateOfBirth': 'Date of Birth',
  'account.overview.toChange':
    'To change your details, contact <bu>{themeName} support</bu>',
  'account.overview.marketingPreferences': '营销参考信息',
  'account.overview.logout': '登出',
  'account.promotionsnotifications.notificationsenabled':
    'Yes, I would like to receive promotional offers',
  'account.promotionsnotifications.email': '邮件',
  'account.promotionsnotifications.sms': '短信',
  'account.promotionsnotifications.phone': '手机',
  'generic.savechanges': '保存更改',
  'generic.account': '账户',
  'generic.stakeWithValue': '注金: {stake}',
  'generic.toggleBalance': '显示/隐藏余额',
  'generic.na': 'N/A',
  'account.mybets.pendingview': '进行中',
  'account.mybets.resultedview': '投注结果',
  'account.mybetscard.noreturn': '本次未中',
  'account.transactions.blended': '混合的 @{odds}',
  'account.transactions.eventDateTimeWithValue': '活动日期/时间: {value}',
  'account.transactions.betIdWithValue': '投注号码: {value}',
  'account.mybetscard.potentialreturns': '预计回报',
  'account.transactions.type.withdrawal': '提款',
  'account.transactions.type.void': '无效',
  'account.transactions.type.adjustment': '调整',
  'account.transactions.type.cashout': '提现',
  'account.transactions.eventDateTime': '事件日期/时间',
  'account.transactions.type.credit': '获胜',
  'account.withdraw.requests.status.withdraw': '提款',
  'betslip.betslipbetcard.errors.multiplelegsineventformulti':
    '您的选择无法组合成过关投注。',
  'account.deposit.creditCardMessage':
    'Please note that we are unable to accept credit card deposits. Please ensure that you utilise your preferred debit card to continue to enjoy uninterrupted betting with us!',
  'account.withdraw.withdrawfundstitle': '提款',
  'account.withdraw.addaccount.makeawithdrawal': '进行提款',
  'account.withdraw.addaccount.withdrawaldescription':
    'Withdrawals may take up to 1-3 days to reach your account. Only turned over funds can be withdrawn.',
  'account.withdraw.addaccount.addaccountbutton': '添加新账户',
  'account.withdraw.addbank': 'Add new Bank account',
  'account.withdraw.withdrawalamountlabel': '金额',
  'account.withdraw.withdrawalbalancelabel': 'Available Balance: ',
  'account.withdraw.requests.status.pending': 'Pending',
  'account.withdraw.requests.status.cancelled': '取消',
  'account.withdraw.requests.status.approved': 'Approved',
  'account.withdraw.requests.status.processed': 'Processed',
  'account.withdraw.requests.status.error': 'Error',
  'account.withdraw.requests.cancelbutton': '取消',
  'account.withdraw.increaseamountbutton.ten': '+$10',
  'account.withdraw.increaseamountbutton.twentyfive': '+$25',
  'account.withdraw.increaseamountbutton.fifty': '+$50',
  'account.withdraw.increaseamountbutton.hundred': '+$100',
  'account.withdraw.increaseamountbutton.twohundred': '+$200',
  'account.withdraw.increaseamountbutton.fivehundred': '+$500',
  'account.withdraw.requestwithdrawalbutton': '提款',
  'account.withdraw.requests.heading': 'Withdrawal Request',
  'account.withdraw.addaccount.bsblabel': 'BSB 号码',
  'account.withdraw.addaccount.accnumberlabel': '账号',
  'account.withdraw.addaccount.nicknamelabel': '昵称（选填）',
  'account.withdraw.addaccount.addaccountsubfooter':
    '请注意：资金只能提取到澳大利亚银行账户。如需帮助，',
  'account.withdraw.addaccount.contactus': '请联系我们。',
  'account.settings.personaldetails': '个人信息',
  'account.settings.responsible': '负责任博彩',
  'account.transactions.noresults': '您没有{pageName}',
  'account.depositlimit.depositlimit': '存款限额',
  'onboarding.login.footerInfo': 'Need an account? <link>Join now</link>',
  'onboarding.login.formTitle': 'Sign in to continue',
  'onboarding.step3.pagetitle': '| 存款限额',
  'onboarding.depositLimit.formTitle': '存款限额',
  'account.overview.promotionalPreferences': 'Promotional Preferences',
  'legal.responsible.tagline3': "What's gambling really costing you?",
  'legal.responsible.tagline5': 'Imagine what you could be buying instead.',
  'account.currentlimit.heading': '存款限额',
  'account.depositlimit.setlimit.subheading2':
    'If you wish to change your existing Deposit Limit, you can do so at any time.  Increasing your limit does require a 7 day cooling-off period before it will take effect.  Lowering your limit, however will come into effect immediately.',
  'account.currentlimit.depositlimitlabel': 'Current limit',
  'account.depositlimit.setlimit.inputplaceholder':
    'Enter a new deposit limit amount',
  'account.currentlimit.newlimitlabel': '限制金额',
  'account.currentlimit.limitperiodlabel': 'Restriction period',
  'account.currentlimit.removelimitbuttontext': 'Remove limit',
  'account.currentlimit.savelimitbuttontext': 'Update limit',
  'account.transactions.transactions.pagetitle': '交易',
  'account.transactions.type.bet': 'Bet Stake',
  'account.transactions.id': 'ID',
  'account.transactions.betId': 'Bet ID',
  'account.transactions.type.winnings': 'Winnings',
  'legal.responsible.section.findOutMore.four.heading':
    'BetStop - National Self Exclusion Register',
  'legal.responsible.section.findOutMore.four.description':
    'If you feel you need to take a break or permanently self exclude from all bookmakers licensed in Australia, you can do this through the BetStop service. See the <cta>BetStop Website</cta> for more information. ',
  'legal.responsible.section.takeaction.depositlimit.one': '存款限额',
  'account.promotionpreferences.coinjar': 'Enable BetSlip Promotions',
  'legal.responsible.section.takeaction.deactivate.two':
    'You can choose to close your account by deactivating it here, or by calling {phonenumber}.',
  'legal.responsible.section.takeaction.lifeexclusion.two':
    'A lifetime exclusion is permanent and cannot be undone. All of your accounts with {getThemeName} will be closed permanently. You will not be able to set up a new account in the future.',
  'legal.responsible.section.takeaction.depositlimit.two':
    '设定一个合理的预算，并控制从您的个人资金中存入的金额，确保您可以负担得起用于投注的金额。',
  'legal.responsible.section.takeaction.break.one': '休息一下',
  'legal.responsible.section.takeaction.lifeexclusion.one': ' ',
  'legal.responsible.section.takeaction.break.two':
    '如果您正在考虑限制投注，您可以选择短暂休息（1 天至 30 天）或长期休息（6 个月至 5 年）。',
  'legal.responsible.tagline1': "Chances are you're about to lose.",
  'legal.responsible.titles.takeaction': '采取行动',
  'legal.responsible.section.takeaction.depositlimit.button': '设置限额',
  'legal.responsible.section.takeaction.deactivate.button': '设置限额',
  'legal.responsible.section.takeaction.break.button': '休息一下',
  'account.personaldetails.header': '个人资料',
  'account.personaldetails.firstNameInputLabel': '名字',
  'account.personaldetails.middleNameInputlabel': '中间名',
  'account.personaldetails.lastNameInputLabel': '姓',
  'account.personaldetails.emailInputLabel': '电子邮件',
  'account.personaldetails.mobileInputLabel': '手机号码',
  'account.personaldetails.addressInputLabel': '地址',
  'account.personaldetails.dobInputLabel': '出生日期',
  'home.viewracecard': '查看比赛数据卡',
  'betslip.button.placebet': '投注',
  'betslip.betslipbetcard.errors.propositionclosed': '此事件已关闭',
  'footer.footerbottomtextSaferTools':
    '我们提供一系列工具，帮助您保持理性博彩。请访问我们的 <link>安全工具</link> 页面了解更多信息。',
  'account.betStop.description':
    'If you feel you need to take a break or permanently self exclude from all bookmakers licensed in Australia, you can do this through the BetStop service. See the <cta>BetStop Website</cta> for more information.',
  'account.betStop.title': 'BetStop - National Self Exclusion Register',
  'account.bonusbets.downloadaction': 'Download Bonus Bets Transaction History',
  'account.bonusbets.downloaderrormessage':
    "Something went wrong, couldn't download bonus bets transactions...",
  'account.bonusbets.nobonusbets': 'You have no Bonus Bets activity',
  'account.closeaccount.clickhere': '请点击此处.',
  'account.closeaccount.closebutton': 'Close account',
  'account.closeaccount.confirmpassword':
    'Confirm account closure with password',
  'account.closeaccount.errormessage': 'Please try again',
  'account.closeaccount.passworderrormessage':
    'Please check your password and try again.',
  'account.closeaccount.text3':
    '如果您因无法再安全博彩而希望关闭账户，请点击此处。 ',
  'account.closeaccount.title': '关闭您的账户',
  'account.closeaccount.validationerrormessage':
    'Please complete the field to continue',
  'account.currentlimit.candecreasesubheading':
    'You can decrease your deposit limit within the 7 day restriction period.',
  'account.currentlimit.coolingoffends': 'Cooling off term ends',
  'account.currentlimit.coolingoffstatement':
    'Your limit will increase to % on the &',
  'account.currentlimit.days': '% days',
  'account.currentlimit.dollars': '$',
  'account.currentlimit.limitRemovalInfo':
    'The removal of your Deposit Limit will come into effect on the {date} at {time}.',
  'account.currentlimit.newLimitInfo':
    'Your new Deposit Limit will come into effect on the {date} at {time}.',
  'account.currentlimit.pendingLimitLabel': 'Pending limit',
  'account.currentlimit.updatelimitheading': 'Update Deposit Limit',
  'account.decreaseupdateconfirmed':
    'Deposit Limit updated. This change will come into effect immediately.',
  'account.deposit.buttons.addnewcard': 'Add New Card',
  'account.deposit.buttons.deposit': 'Deposit now',
  'account.deposit.buttons.maxcards': '您最多只能添加 * 张卡',
  'account.deposit.card.expired': 'Expired',
  'account.deposit.card.savecard': 'Save card details',
  'account.deposit.confirmation.cardNotSupported':
    'Transaction failed: this card is not supported. Please try a different card',
  'account.deposit.confirmation.cardexist': 'The card already exists!',
  'account.deposit.confirmation.done': 'Done',
  'account.deposit.confirmation.failed': 'Deposit Failed',
  'account.deposit.confirmation.failedmessage':
    'Your deposit of % was not successful.',
  'account.deposit.confirmation.pleasetryagain': 'Please, Try Again',
  'account.deposit.confirmation.success': 'Success!',
  'account.deposit.depositMatch.activated': 'Deposit match activated',
  'account.deposit.increaseamountbutton.fifty': '+$50',
  'account.deposit.increaseamountbutton.fivehundred': '+$500',
  'account.deposit.increaseamountbutton.hundred': '+$100',
  'account.deposit.increaseamountbutton.ten': '+$10',
  'account.deposit.increaseamountbutton.thousand': '+$1000',
  'account.deposit.labels.or': 'OR',
  'account.deposit.labels.securedwithssl':
    'Secured with SSL encryption technology.',
  'account.deposit.labels.selectcard': 'Select a Card',
  'account.deposit.toasts.cardremovesuccessful': 'Card successfully deleted',
  'account.deposit.toasts.fzerrors.002':
    'Unable to verify 3DS enrolment status with you issuer.',
  'account.deposit.toasts.fzerrors.003':
    '3DS authentication is unavailable with your issuer.',
  'account.deposit.toasts.fzerrors.004':
    'Your issuer deems this transaction as risky.',
  'account.deposit.toasts.fzerrors.005':
    'Your frictionless authentication has been rejected.',
  'account.deposit.toasts.fzerrors.006':
    'Unsuccessful authentication due to failed OTP (one time password) challenge.',
  'account.deposit.toasts.fzerrors.007':
    'You are enrolled for 3DS, but authentication is not available with your issuer.',
  'account.deposit.toasts.fzerrors.01':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.02':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.03': 'Check your merchant details provided',
  'account.deposit.toasts.fzerrors.04':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.05':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.06':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.07':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.12':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.13':
    'Invalid amount, contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.14':
    'Invalid card number, contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.15':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.19': 'Payment failed, please try again',
  'account.deposit.toasts.fzerrors.22': 'Payment failed, please try again',
  'account.deposit.toasts.fzerrors.23':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.25':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.30':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.31':
    'Your bank is not supported, contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.33':
    'Card has expired, please use a different card',
  'account.deposit.toasts.fzerrors.34':
    'Card has expired, please use a different card',
  'account.deposit.toasts.fzerrors.35':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.36':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.37':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.38': 'Please use another card',
  'account.deposit.toasts.fzerrors.39':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.41':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.42':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.43':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.44':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.51': 'Insufficient funds',
  'account.deposit.toasts.fzerrors.52':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.53':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.54':
    'Expired card, please use a different card',
  'account.deposit.toasts.fzerrors.55': 'Payment failed, please try again',
  'account.deposit.toasts.fzerrors.56':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.57':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.59':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.60':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.61': 'Please try another card',
  'account.deposit.toasts.fzerrors.62':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.75': 'Please use another card',
  'account.deposit.toasts.fzerrors.82': 'Payment failed, please try again',
  'account.deposit.toasts.fzerrors.90': 'Payment failed, please try again',
  'account.deposit.toasts.fzerrors.91': 'Payment failed, please try again',
  'account.deposit.toasts.fzerrors.92': 'Payment failed, please try again',
  'account.deposit.toasts.fzerrors.93':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.94':
    'Contact your card issuer for more information',
  'account.deposit.toasts.fzerrors.96': 'Payment failed, please try again',
  'account.deposit.toasts.fzerrors.99': 'Payment failed, please try again',
  'account.deposit.toasts.paymentsuccessful':
    'Successfully deposited your funds',
  'account.deposit.toasts.paymentunsuccessful':
    'Payment was unsuccessful, you have not been charged',
  'account.deposit.toasts.somethingWentWrong':
    'Something went wrong, please try again',
  'account.deposit.toasts.unabletoaddcard': 'Unable to add a new card',
  'account.deposit.toasts.unabletodepositfunds':
    'We were unable deposit your funds',
  'account.deposit.toasts.unabletogetcards': 'Unable to get your saved cards',
  'account.deposit.toasts.unabletoprocesscard':
    'We were unable to process your card, please try again',
  'account.deposit.toasts.unabletoremovecard':
    'Unable to remove your saved card',
  'account.deposit.validation.maxamount':
    'Your deposit limit has been reached.',
  'account.deposit.validation.minamount': 'Min amount is $10',
  'account.depositlimit.setlimit.depositlimitlabel': '限制金额',
  'account.depositlimit.setlimit.error':
    'There was an error updating your deposit limit. Please try again.',
  'account.depositlimit.setlimit.formsubtext': 'You can deposit ',
  'account.depositlimit.setlimit.formsubtextbold': 'up to % every & days',
  'account.depositlimit.setlimit.heading': '设置存款限额',
  'account.depositlimit.setlimit.limitperiodlabel': '限额时长',
  'account.depositlimit.setlimit.limitupdated':
    'Your deposit limit has been successfully updated.',
  'account.depositlimit.setlimit.setlimitbuttontext': 'Set Deposit Limit',
  'account.errorstrings.cannotincrease':
    'Deposit limit cannot be increased until %',
  'account.errorstrings.numbersonly': 'Deposit limit can only contain numbers',
  'account.errorstrings.requiredamount': 'Deposit limit amount is required',
  'account.errorstrings.requiredperiod': 'Deposit limit period is required',
  'account.errorstrings.samevalue':
    'Amount entered is the same as your current deposit limit',
  'account.increaseupdateconfirmed':
    'Deposit Limit updated. This change will come into effect in 7 days.',
  'account.lifetimeExclusionConfirmation': 'You have been excluded for life',
  'account.lifetimeexclusion.confirmstepimmediately': '禁止条款将立即生效',
  'account.lifetimeexclusion.confirmstepundone':
    '禁止是永久性的，我在 {themeName} 的所有账户将被永久关闭',
  'account.lifetimeexclusion.errortoast': 'Please try again',
  'account.lifetimeexclusion.importantdetailsalertstitle': '2. 电子邮件和提醒',
  'account.lifetimeexclusion.informationlongbreak': '6 months.',
  'account.lifetimeexclusion.informationshortbreak': 'break from 1 day ',
  'account.lifetimeexclusion.informationtext2': 'up to ',
  'account.lifetimeexclusion.informationtext4':
    '继续操作后，您将无法再使用 {themeName} 投注或在 {themeName} 开设有效账户。',
  'account.lifetimeexclusion.pagetitle': '无期限自我禁止',
  'account.lifetimeexclusion.validationerrormessage':
    'Please complete the field to continue',
  'account.limitperiodoptions.0': '1 Day',
  'account.limitperiodoptions.1': '7 Days',
  'account.limitperiodoptions.2': '14 Days',
  'account.limitperiodoptions.3': '28 Days',
  'account.makeaclaim.contactus': 'How to contact us:',
  'account.makeaclaim.contactusdesc': 'Email us at: ',
  'account.makeaclaim.howweresolve': 'How we resolve claims?',
  'account.makeaclaim.resolveclaims': 'How we resolve claims?',
  'account.makeaclaim.resolveclaimsdesc':
    'By email: We will respond to your complaint within 48 hours and provide you with an indication of how long it will take to resolve.',
  'account.myBetsCard.atBestToteAbbrev': '@BT',
  'account.myBetsCard.atStartingPriceAbbrev': '@SP',
  'account.myBetsCard.atToteAbbrev': '@MD',
  'account.myBetsCard.boostedOdds': 'Boosted Odds',
  'account.myBetsCard.moneyBack': 'Money Back',
  'account.myBetsCard.msyteryBetHeader': 'Mystery Bet',
  'account.myBetsCard.msyteryBetHeaderWithRollover':
    'Mystery Bet With Rollover',
  'account.mybets.cashout.Accept': '接受',
  'account.mybets.cashout.BetAlreadySettled':
    'We are unable to process your request',
  'account.mybets.cashout.BetDoesntExist':
    'We are unable to process your request',
  'account.mybets.cashout.BetNotEligible':
    'We are unable to process your request',
  'account.mybets.cashout.CashOut': 'Cash Out',
  'account.mybets.cashout.CashOutQuestion':
    ' Are you sure you want to Cash Out for ',
  'account.mybets.cashout.CashedOut': 'CASHED OUT',
  'account.mybets.cashout.CashoutDisabled':
    'We are unable to process your request',
  'account.mybets.cashout.CashoutSuspended':
    'Your Cash Out could not be processed as the match has been Suspended',
  'account.mybets.cashout.CustomerNotEligible':
    'We are unable to process your request',
  'account.mybets.cashout.Decline': 'Decline',
  'account.mybets.cashout.Done': 'DONE',
  'account.mybets.cashout.EstReturn': '预计回报',
  'account.mybets.cashout.error': 'Something went wrong.',
  'account.mybets.cashout.oddsChangeAutoAccept':
    'Your Cash Out offer has increased and you have successfully Cashed Out.',
  'account.mybets.cashout.oddsChangeRequireAccept':
    'Your Cash Out amount has decreased, please review before accepting.',
  'account.mybets.cashout.success': 'You have successfully Cashed Out.',
  'account.mybets.loading': 'Loading...',
  'account.mybets.nobets': 'You have no more bets to display',
  'account.mybets.nobetstext': 'You have no {filterName} bets',
  'account.mybets.pending': 'pending',
  'account.mybets.resulted': 'resulted',
  'account.mybets.showmore': 'Show more',
  'account.mybetscard.badges.bonusbet': '礼金投注',
  'account.mybetscard.badges.deductions': 'Deductions applied',
  'account.mybetscard.badges.deductionsmayapply': 'Deductions may apply',
  'account.mybetscard.betidtext': 'Bet ID:',
  'account.mybetscard.betplaced': 'Bet Placed On:',
  'account.mybetscard.bonus': 'Bonus {winnings}',
  'account.mybetscard.bonusapplied': 'Bonus Applied',
  'account.mybetscard.cancelled': '取消',
  'account.mybetscard.combinedEstReturn': 'Combined Est. Return',
  'account.mybetscard.legmulti': 'Leg Multi',
  'account.mybetscard.legs': 'Legs',
  'account.mybetscard.less': 'Less',
  'account.mybetscard.more': 'More',
  'account.mybetscard.raceabbv': 'R',
  'account.mybetscard.stake': '注金',
  'account.mybetscard.void': 'Void',
  'account.overview.account': '账户',
  'account.overview.accountbalance': 'Account Balance: ',
  'account.overview.bonus': 'Bonus',
  'account.overview.bonusbalance': 'Bonus Balance: ',
  'account.overview.getverified': 'Get Verified',
  'account.overview.mustverify':
    'You must verify your account in order to make a withdrawal',
  'account.overview.pagetitle': '| Account Overview',
  'account.overview.verification.mustBeVerified':
    'Your account <u>must</u> be verified to make withdrawals.',
  'account.overview.verification.pending': 'Pending',
  'account.overview.verification.unverified': 'Get Verified',
  'account.overview.verification.verified': 'Verified',
  'account.overview.verificationstatus': 'Verification Status',
  'account.overview.withdraw': '提款',
  'account.overview.withdrawablebalance': 'Withdrawable Balance: ',
  'account.personalDetails.titlePlaceholder': 'Select',
  'account.personaldetails.button': '保存更改',
  'account.personaldetails.pageTitle': '| Personal Details',
  'account.personaldetails.postcodeinputlabel': 'Postcode',
  'account.personaldetails.postcodelengtherror': 'Postcode must be 4 digits',
  'account.personaldetails.stateinputlabel': 'State',
  'account.personaldetails.streetnameinputlabel': '街道名称',
  'account.personaldetails.streetnumberinputlabel': '街道号码',
  'account.personaldetails.submiterror':
    'There was an error updating your personal details',
  'account.personaldetails.submitsuccess':
    'Personal details successfully updated.',
  'account.personaldetails.suburbinputlabel': '区/县',
  'account.personaldetails.titleInputLabel': 'Title',
  'account.privacy.otherlinks.depositlimits': 'Deposit Limits',
  'account.privacy.otherlinks.terms': '条款和条件',
  'account.privacy.pageTitle': '隐私政策',
  'account.promos.pageTitle': 'Promos',
  'account.promotionpreferences.error':
    'Failed to update promotional preferences',
  'account.promotionpreferences.success':
    'Promotional preferences were updated',
  'account.promotionsnotifications.pagetitle': 'Marketing preferences',
  'account.promotionsnotifications.post': 'Post',
  'account.promotionsnotifications.submiterror':
    'Error updating marketing preferences...',
  'account.promotionsnotifications.submitsuccess':
    'Marketing Preferences successfully updated!',
  'account.promotionsnotifications.via': 'via',
  'account.removeconfirmmodal.title': 'Remove Deposit Limit',
  'account.settings.accountverification': 'Account Verification',
  'account.settings.makeaclaim': 'Make a Claim',
  'account.settings.pagetitle': 'Settings',
  'account.settings.promotionsnotifications': 'Marketing preferences',
  'account.settings.updateemail': 'Update Email',
  'account.signedout.subtitle': ' ',
  'account.signedout.title': 'The user is signed out',
  'account.takeabreak.breakstartdate': 'Break start date:',
  'account.takeabreak.confirm':
    'By pressing on “Confirm Break”, I understand that:',
  'account.takeabreak.confirmbutton': 'Confirm break',
  'account.takeabreak.confirmstepimmediately':
    'My break will take effect immediately',
  'account.takeabreak.confirmsteppendingbets':
    '我 {themeName} 账户中的所有资金将转入我最后一次使用的付款方式',
  'account.takeabreak.confirmstepundone': 'The break cannot be undone',
  'account.takeabreak.continuebutton': '继续',
  'account.takeabreak.dayperiod': 'In X day',
  'account.takeabreak.dayperiodplural': 'In X days',
  'account.takeabreak.errortoast': 'Please try again',
  'account.takeabreak.importantdetailsemaildesc':
    '您将不再收到 {themeName} 发送的电子邮件和其他提醒。这些将在您的休息确认开始后 24 小时内终止。',
  'account.takeabreak.limitperiod': '限额时长',
  'account.takeabreak.period1month': '1 month',
  'account.takeabreak.period24': '24 hrs',
  'account.takeabreak.period3months': '3 months',
  'account.takeabreak.period48': '48 hrs',
  'account.takeabreak.period6months': '6 months',
  'account.takeabreak.period72': '72 hrs',
  'account.takeabreak.periodformat': '(in X)',
  'account.takeabreak.periodfortnight': '2 weeks',
  'account.takeabreak.periodweek': '1 week',
  'account.takeabreak.today': '今天',
  'account.takeabreak.validationerrormessage':
    'Please complete the field to continue',
  'account.terms.otherlinks.depositlimits': '存款限额',
  'account.terms.otherlinks.privacy': '隐私政策',
  'account.terms.pagetitle': '条款和条件',
  'account.transactions.bonus': 'Bonus',
  'account.transactions.download': 'Download',
  'account.transactions.downloadaction': 'Download Spreadsheet',
  'account.transactions.downloaderrormessage':
    "Something went wrong, couldn't download transactions...",
  'account.transactions.exotics.boxed': '合票',
  'account.transactions.leg': 'Leg Multi',
  'account.transactions.legs': 'Legs',
  'account.transactions.noactivity': 'No Activity',
  'account.transactions.notransactions': 'You have no transactions',
  'account.transactions.propDetailsForSP': '{proposition} @ SP',
  'account.transactions.refund': 'Refund',
  'account.transactions.sgmTransactionTitle':
    '{hasOdds, select, true {{legCount} Leg 单场多倍 @{odds}} other {{legCount} Leg 单场多倍}}',
  'account.transactions.tableheadings.0': 'Status',
  'account.transactions.tableheadings.1': 'Date',
  'account.transactions.tableheadings.2': 'Type',
  'account.transactions.tableheadings.3': 'Bet Details',
  'account.transactions.tableheadings.4': 'Odds',
  'account.transactions.tableheadings.5': '注金',
  'account.transactions.tableheadings.6': '金额',
  'account.transactions.type.bonus': 'Bonus',
  'account.transactions.type.exotics.boxed': '合票',
  'account.transactions.type.refund': 'Refund',
  'account.updateConfirmModal.subheadingDecreasing':
    'You will be able to deposit up to {amount} every {frequency} day(s). {br}This will come into effect immediately.',
  'account.updateConfirmModal.subheadingIncreasing':
    'You will be able to deposit up to {amount} every {frequency} day(s). {br} <note><noteTitle>Note:</noteTitle> Your update will come into effect after the 7 day cooling-off period.</note>',
  'account.updateConfirmModal.subheadingRemoval':
    'Are you sure you want to remove your Deposit Limit? {br} <note><noteTitle>Note:</noteTitle> Your update will come into effect after the 7 day cooling-off period.</note>',
  'account.updateconfirmmodal.cancel': '取消',
  'account.updateconfirmmodal.confirm': '确认',
  'account.updateconfirmmodal.title': 'Update Deposit Limit',
  'account.updateemail.emailrequired': 'Your email address is required',
  'account.updateemail.failmessage': 'There was an issue updating your email',
  'account.updateemail.header': 'Update your email',
  'account.updateemail.pagetitle': '| Update Email',
  'account.updateemail.successmessage': 'Updated email successfully.',
  'account.verifyidentity.failed': 'Unable to verify account',
  'account.verifyidentity.header': 'Verify Your Identity',
  'account.verifyidentity.pagetitle': '| Verify Identity',
  'account.verifyidentity.statuscomplete': 'Your identity is verified.',
  'account.verifyidentity.statusfailed':
    'Unable to verify your identity. Please',
  'account.verifyidentity.statusfailedlink': 'contact support',
  'account.verifyidentity.statusinprogress':
    'Your identity verification is in progress.',
  'account.verifyidentity.statuspending':
    'Your identity verification is pending manual review.',
  'account.withdraw.addaccount.banknamelabel': 'Bank Name',
  'account.withdraw.addaccount.errorstrings.accountnumberformat':
    'Must be a valid Australian Account Number',
  'account.withdraw.addaccount.errorstrings.accountnumbernospaces':
    'Account Number cannot contain spaces',
  'account.withdraw.addaccount.errorstrings.accountnumberrequired':
    'Account Number is required',
  'account.withdraw.addaccount.errorstrings.banknamerequired':
    'Bank name is required',
  'account.withdraw.addaccount.errorstrings.bsbformat':
    'Must be a valid Australian BSB Number',
  'account.withdraw.addaccount.errorstrings.bsbnumbernospaces':
    'BSB Number cannot contain spaces',
  'account.withdraw.addaccount.errorstrings.bsbrequired': 'BSB is required',
  'account.withdraw.addaccount.errorstrings.genericerror':
    'There was an error adding this bank account',
  'account.withdraw.addaccount.errorstrings.namerequired':
    'Account Holders name is required',
  'account.withdraw.addaccount.heading': 'Add Bank Account',
  'account.withdraw.addaccount.holdernamelabel': '账户持有人姓名',
  'account.withdraw.addaccount.holdernamesubfooter':
    '银行账户必须使用注册账户持有人的全名',
  'account.withdraw.addaccount.nicknamesubfooter':
    'Add a nickname to help distinguish this bank account from others',
  'account.withdraw.bankcard.acc': 'ACC',
  'account.withdraw.bankcard.bsb': 'BSB',
  'account.withdraw.bankcard.hiddenaccnumber': '*****',
  'account.withdraw.bankcard.hiddenbsb': '*** ***',
  'account.withdraw.errorstrings.amountexceeds':
    'Amount exceeds withdrawable of ',
  'account.withdraw.errorstrings.amountrequired': 'Withdraw amount is required',
  'account.withdraw.errorstrings.bankrequired': 'Bank account is required',
  'account.withdraw.errorstrings.cannotwithdrawerror':
    'You cannot withdraw funds until they’ve been turned over',
  'account.withdraw.errorstrings.integer':
    'Withdraw amount can only contain numbers',
  'account.withdraw.errorstrings.minimumAmount':
    'Withdrawal amount must be more than $10',
  'account.withdraw.pagetitle': '提款',
  'account.withdraw.request.heading': 'Withdrawal Request',
  'account.withdraw.requests.remove': '移除',
  'account.withdraw.requests.requestunsuccessful':
    'Request unsuccessful please contact customer support.',
  'account.withdraw.requests.status.dash': ' - ',
  'account.withdraw.requests.status.unsuccessful': 'Unsuccessful',
  'account.withdraw.withdrawalcancelled': 'Request successfully cancelled',
  'account.withdraw.withdrawalsuccess': 'Withdrawal request successful',
  'account.withdraw.withdrawsubfooter1':
    'Withdrawals may take up to 1-3 days to reach your account',
  'account.withdraw.withdrawsubfooter2': '只能提取流转过的资金。',
  'betSlip.betSlipBetCard.approved': 'approved',
  'betSlip.betSlipBetCard.errors.startingPrice':
    'A Multi Bet cannot include SP bets.',
  'betSlip.betSlipBetCard.rejected': '{amount} has been rejected',
  'betSlip.betSlipModal.betRecoveryAlert':
    'This bet is eligible for <b>Bet Recovery!</b>',
  'betSlip.betSlipModal.blendedHeader': '混合',
  'betSlip.betSlipModal.multiHeader': '{legCount} Leg Multi',
  'betSlip.betSlipModal.sgmHeader': '{legCount} Leg <span>单场多倍</span>',
  'betSlip.combinedEstPayout': 'Combined Est. Payout:',
  'betSlip.oddsBoosted': 'Odds Boosted',
  'betslip.betslipbetcard.approved': 'approved.',
  'betslip.betslipbetcard.bal': 'Bal',
  'betslip.betslipbetcard.betapprovalinfo': 'Your bet has been ',
  'betslip.betslipbetcard.betidlabel': 'Bet ID:',
  'betslip.betslipbetcard.emptyflexerror': 'Flexi required',
  'betslip.betslipbetcard.emptystakeerror': 'Stake required',
  'betslip.betslipbetcard.errors.accountclosed':
    'We were unable to process your request. Contact support for further assistance.',
  'betslip.betslipbetcard.errors.alreadyprocessedrequest':
    'We were unable to process your request. Contact support if the issue persists.',
  'betslip.betslipbetcard.errors.betsliprejection':
    'We were unable to process your request. Contact support for further assistance.',
  'betslip.betslipbetcard.errors.duplicaterequest':
    'Bet Rejected, duplicate identified.',
  'betslip.betslipbetcard.errors.exceededmaximumlegsformulti':
    'A Multi Bet must not exceed 20 legs.',
  'betslip.betslipbetcard.errors.highrisk':
    'We were unable to process your request. Contact support if the issue persists.',
  'betslip.betslipbetcard.errors.insufficentfund':
    'Your balance is too low. Lower your stake or make a deposit to cover your bets.',
  'betslip.betslipbetcard.errors.insufficientlegsformulti':
    'Insufficient legs to place a Multi.',
  'betslip.betslipbetcard.errors.invalidproposition':
    'Betting is no longer available on your selection.',
  'betslip.betslipbetcard.errors.manualrejection':
    'Unfortunately, your bet has been rejected.',
  'betslip.betslipbetcard.errors.multi.propositionClosed.removeBet':
    'Some propositions in your multi have closed. Add more bets to create a new multi.',
  'betslip.betslipbetcard.errors.multi.propositionClosed.updateConfirm':
    'Some propositions in your multi have closed. Please review your selections before confirming',
  'betslip.betslipbetcard.errors.negativestake': 'Invalid Stake.',
  'betslip.betslipbetcard.errors.oddsChange.decrease':
    'Your odds have changed. Please review your selections before confirming.',
  'betslip.betslipbetcard.errors.oddsChange.increase':
    'Congratulations! Your odds have increased.',
  'betslip.betslipbetcard.errors.placebetinvalidfieldsize':
    'Betting is no longer available on your selection.',
  'betslip.betslipbetcard.errors.selectionexpansionrejection':
    'We were unable to process your request. Contact support if the issue persists.',
  'betslip.betslipbetcard.errors.unknownerror':
    'Your submission was unsuccessful. Please try again.',
  'betslip.betslipbetcard.errors.unsupportedbettype':
    'Unable to place this bet type.',
  'betslip.betslipbetcard.fixedpriceplacelabel': '排名 (Fixed Price)',
  'betslip.betslipbetcard.fixedpricewinlabel': '获胜 (Fixed Price)',
  'betslip.betslipbetcard.multis.estnoreturns': '预计回报 $0.00',
  'betslip.betslipbetcard.multis.estreturns': '预计回报',
  'betslip.betslipbetcard.multis.ineligiblepropositions':
    'Some selections in your betslip are not eligible for a multibet',
  'betslip.betslipbetcard.multis.leg': 'Leg',
  'betslip.betslipbetcard.multis.legmulti': 'Leg Multi',
  'betslip.betslipbetcard.multis.multimorethan20props':
    'You can only place up to 20 legs in a single Multi',
  'betslip.betslipbetcard.negativevalueerror': 'Negative value',
  'betslip.betslipbetcard.partialbetapprovalinfo': '% has been ',
  'betslip.betslipbetcard.pendingapproval': 'Pending approval',
  'betslip.betslipbetcard.placed': 'Bet Placed: ',
  'betslip.betslipbetcard.rejected': 'rejected.',
  'betslip.betslipbetcard.srm.error': 'Something went wrong',
  'betslip.betslipbetcard.srm.top': 'Top {index}:',
  'betslip.betslipbetcard.stake': '注金',
  'betslip.betslipbetcard.stakepercombo': 'Stake per combo',
  'betslip.betslipbetcard.thiseventisclosed': 'This event is closed',
  'betslip.betslipbetcard.winlabel': '奖金',
  'betslip.betslipheading': '投注单',
  'betslip.betslipmodal.bet': 'Bet',
  'betslip.betslipmodal.betgalaxyemptybetslipheading':
    'Houston, your bet slip is empty!',
  'betslip.betslipmodal.clearbets': '清除',
  'betslip.betslipmodal.confirmbets': 'Confirm Bets',
  'betslip.betslipmodal.editbets': 'Edit Bets',
  'betslip.betslipmodal.emptymultibets':
    'Add more single bets to create a multi, or combine with a same game multi and increase your potential win',
  'betslip.betslipmodal.exotictypes.exacta': '精确双选',
  'betslip.betslipmodal.exotictypes.firstfour': 'First 4',
  'betslip.betslipmodal.exotictypes.quinella': '任意双选',
  'betslip.betslipmodal.exotictypes.trifecta': '精确三选',
  'betslip.betslipmodal.genericerror':
    'An unknown error occurred. Please try again',
  'betslip.betslipmodal.login': 'Login & Bet',
  'betslip.betslipmodal.lowerstakedescription': 'Lower your stake or deposit',
  'betslip.betslipmodal.lowerstakeheading': 'Your balance is too low',
  'betslip.betslipmodal.makeadeposit': 'Make a deposit',
  'betslip.betslipmodal.placedbetsconfirmation': 'Your bets have been placed.',
  'betslip.betslipmodal.stakeRoundedDown':
    'Your stake has been rounded down to the nearest valid stake of {stake}',
  'betslip.betslipmodal.types.blended': '混合',
  'betslip.betslipmodal.types.combomulti': 'Combo Multis',
  'betslip.betslipmodal.types.eachway': 'Each Way',
  'betslip.betslipmodal.types.exotics': 'Exotics',
  'betslip.betslipmodal.types.sgmulti': '单场多倍',
  'betslip.betslipmodal.types.totemulti': 'Multiples',
  'betslip.betslipmodal.updateconfirmbets': 'Update & Confirm',
  'betslip.betslipreceiptheading': 'Bet Receipt',
  'betslip.betslipreviewheading': 'Review & Confirm',
  'betslip.bonusbetapplied': 'Bonus Bet Applied!',
  'betslip.eachway': 'Each Way',
  'betslip.emptybetsmodal.emptymodalmessage':
    'You must enter a stake to place a bet',
  'betslip.emptybetsmodal.modalbutton': 'Ok',
  'betslip.emptybetsmodal.warningheading': 'Warning',
  'betslip.eventrules.noplace': 'No place betting available on this race',
  'betslip.eventrules.ruleheading': 'Event Rules: ',
  'betslip.eventrules.threeplacedividends': 'Three place dividends paid',
  'betslip.eventrules.twoplacedividends': 'No third dividend',
  'betslip.negativeerror': 'Negative stake',
  'betslip.usebonusbet': 'Use Bonus Bet',
  'bonus.browserSupport': 'Your browser does not support the video tag.',
  'bonus.claimBonus': 'Claim bonus',
  'bonus.youWon': 'You won',
  'contactus.chat': '在线客服',
  'contactus.phonelocal': '(Local)',
  'contactus.support': 'Support - ',
  'depositLimit.modal.radio.limit.change': 'Change my Deposit Limit',
  'depositLimit.modal.radio.limit.keep':
    'Keep my existing Deposit Limit of {limit} every {frequency} days',
  'depositLimit.modal.radio.limit.remove': 'Remove my existing Deposit Limit',
  'depositLimit.modal.title.hasLimit':
    'Would you like to change your existing Deposit Limit?',
  'depositLimit.modal.title.noLimit': 'Would you like to set a Deposit Limit?',
  'depositLimit.modal.toast.fail.simple':
    'Unable to update your deposit limit. Please try again.',
  'depositLimit.modal.toast.success.props':
    'Your deposit limit has been successfully updated and will come into effect on {formattedDate} {formattedTime}',
  'depositLimit.modal.toast.success.simple':
    'Your deposit limit has been successfully updated',
  'errorboundary.desc':
    'Theres been an unknown error, please refresh and try again.',
  'errorboundary.title': 'Theres been an error!',
  'footer.appversion': 'v{appVersion}',
  'footer.bodymain2phonenumber': '1800 262 376',
  'footer.bodysecondary': 'Licensed and regulated by Racing Victoria.',
  'footer.copyrightNoPty': '版权所有 © {themeName} | v{appVersion}',
  'footer.copyrightNoTheme': '版权所有 © {abn} | v{appVersion}',
  'footer.footerbottomtextnt':
    'We are licensed and regulated by the <link>Northern Territory Racing Commission</link>.  For South Australian residents, we are governed by the Authorised Betting Operations Gambling <code>Code Of Practice.</code>',
  'footer.newfootertext1':
    '{getThemeName} are committed to the support of responsible gambling. All bets are accepted by {getThemeName} who are licensed in Victoria by the Victorian Commission for Gambling and Liquor.',
  'footer.newfootertext3':
    'Think of the people who need your support. Gamble Responsibly.',
  'footer.newfootertext4':
    'Please gamble responsibly and if you need help call Gambling Help services on',
  'footer.support': 'Support - {themeName}',
  'generic.accept': 'Accept',
  'generic.addtoBetSlip': 'Add to Betslip',
  'generic.allMarkets': 'All Markets',
  'generic.and': '和',
  'generic.bestTotePlaceMarket': 'Best TOTE Racing Place',
  'generic.bestToteWinMarket': 'Best TOTE Racing Win',
  'generic.bet': 'Bet',
  'generic.betTypeNotSupported': 'You do not have access to this bet type',
  'generic.bets': 'Bets',
  'generic.bonus': 'Bonus: ',
  'generic.cancel': '取消',
  'generic.cashOut': 'Cash Out',
  'generic.cashedOut': 'Cashed Out',
  'generic.clear': '清除',
  'generic.countryOthers': '其他的',
  'generic.decline': 'Decline',
  'generic.done': 'Done',
  'generic.emptystake': '0.00',
  'generic.error':
    'Sorry, Mystery Bet is not currently available at this price on this race',
  'generic.erroroccurred': 'An error occurred. Please try again',
  'generic.errors.accesDenied': 'Access Denied',
  'generic.errors.default': 'An error occurred. Please try again later.',
  'generic.errors.error': 'Error',
  'generic.errors.rateLimit': 'Please wait a few moments and try again',
  'generic.favorites': 'Favourites',
  'generic.fixedeachway': 'Fixed Each Way',
  'generic.flexi': 'Flexi',
  'generic.gamblershelp': 'Gambler`s Help',
  'generic.helpline': '1800 858 858',
  'generic.join': '立即加入',
  'generic.loading': 'Loading...',
  'generic.login': '登录',
  'generic.loginToView': 'Login to view',
  'generic.marketCount':
    '{marketCount, plural, one {1 Market} other {# Markets}}',
  'generic.marketNameWithSP': '{marketName} (SP)',
  'generic.markets': ' Markets',
  'generic.moneyBack': 'Money Back',
  'generic.nopolicyfound': 'No policy found',
  'generic.password': '密码',
  'generic.pickdate': 'Pick a Date',
  'generic.policy': '政策',
  'generic.popups':
    'Please disable your pop-up blocker or allow pop-ups for this site to view the content.',
  'generic.potentialWinnings': 'Potential Winnings',
  'generic.race': 'Race',
  'generic.required': 'Required',
  'generic.restrictedfuture': 'Date cannot be in the future',
  'generic.restrictedpast': 'Date cannot be in the past',
  'generic.sameGameMulti': '单场多倍',
  'generic.scratched': 'Scratched',
  'generic.seeall': 'See All',
  'generic.selectplaceholder': 'Please Select',
  'generic.signup': '报名',
  'generic.submit': 'Submit',
  'generic.sus': 'SUS',
  'generic.teamOrEventSearch': 'FIND YOUR TEAM OR EVENT...',
  'generic.topLeagues': 'Top leagues',
  'generic.totePlaceMarket': 'Mid Div Racing Place',
  'generic.toteWinMarket': 'Mid Div Racing Win',
  'generic.unverified': 'Unverified',
  'generic.verified': 'Verified',
  'generic.version': 'Version',
  'generic.viewMore': 'View more',
  'generic.win': '奖金',
  'helpcentre.policy.association':
    "{themeName} is a member of the Victorian Bookmakers' Association and adheres to the Victorian Bookmakers Association Responsible Gambling Code of Conduct. A copy of the Code of Conduct can be downloaded from the <website>https://vicbookmakers.com.au/responsible-gambling/</website> ",
  'helpcentre.policy.getHelp':
    'https://www.responsiblegambling.vic.gov.au/getting-help',
  'helpcentre.promotions.description':
    'Promotions and Featured Markets are subject to our Promotion Terms and Conditions.',
  'helpcentre.promotions.modal.terms':
    'All promotional offers are subject to {bookieName} Terms & Conditions and Promotional Terms & Conditions',
  'helpcentre.promotions.specials': 'Specials',
  'helpcentre.promotions.termsAndConditions': '使用条款',
  'home.carousel.accessbility': 'Carousel content displaying a banner.',
  'home.nextToPlay': 'Next to play',
  'home.nexttojumpheading': '即将开赛',
  'home.pagetitle': '| Home',
  'home.upcomingsportsheading': 'Upcoming Sports',
  'legal.responsible.section.takeaction.longterm.button': 'Long Term Exclusion',
  'legal.responsible.section.takeaction.longterm.one': ' ',
  'legal.responsible.section.takeaction.longterm.two':
    'Stop betting by suspending your account for over 6 months or any other period up to a maximum of 5 years.',
  'legal.responsible.titles.findoutmore': 'Find out more',
  'maintenance.closingtaglinebetgalaxy':
    '. Ground control are looking into the issue as a high priority. We apologise and thank you for your patience.',
  'maintenance.closingtaglinewellbet':
    '. Our technical teams are looking for a solution as a high priority. We apologise and thank you for your patience.',
  'maintenance.contentheaderbetgalaxy': 'Punter, we have a problem',
  'maintenance.contentheaderwellbet': 'Give us a minute!',
  'maintenance.investigation':
    'We are currently investigating the issue. Please try again soon.',
  'maintenance.openingtagline':
    'We are currently having some technical issues at ',
  'maintenance.ouroffices': 'Our Offices',
  'mysteryBet.rollOver': 'Roll Over',
  'onboarding.firebaseerrormessages.emailinuse':
    'This email address is already in use.',
  'onboarding.firebaseerrormessages.errorcreatingaccount':
    'There was an issue creating your account:',
  'onboarding.firebaseerrormessages.unspecifiederror':
    'An unspecified error occurred. Please try again later.',
  'onboarding.firebaseerrormessages.userdisabled':
    'Your account has been disabled.',
  'onboarding.firebaseerrormessages.usernotfound':
    'Unable to find your account.',
  'onboarding.firebaseerrormessages.wrongcredentials':
    "Your credentials don't seem to be correct. Please try again.",
  'onboarding.forgotpassword.bodytext':
    'Please enter your email below and we will send you a link to reset your password.',
  'onboarding.forgotpassword.header': '忘记密码',
  'onboarding.forgotpassword.loginlink': 'Click here to login',
  'onboarding.forgotpassword.pagetitle': '| 忘记密码',
  'onboarding.forgotpassword.title': '忘记密码？',
  'onboarding.locationnotallowed.bodycopyntone':
    '{themeName} 仅面向澳大利亚客户提供服务。如果您身在澳大利亚，但认为错误地看到了此页面，请通过 ',
  'onboarding.locationnotallowed.bodycopynttwo':
    '{themeName} is licensed and regulated by the ',
  'onboarding.locationnotallowed.locationenquiry': 'Location Enquiry - ',
  'onboarding.locationnotallowed.nt':
    '<link> Northern Territory Racing Commission</link>.',
  'onboarding.locationnotallowed.ouroffices': 'Our Offices',
  'onboarding.locationnotallowed.pagetitle': '| Location not allowed',
  'onboarding.login.autologoutmessage':
    'You have been automatically signed out due to inactivity. Please sign in again.',
  'onboarding.login.button': '登录',
  'onboarding.login.error_closed_account':
    'Your account has been closed. Please contact support to reactivate the account',
  'onboarding.login.error_permanent_exclusion':
    'Your account has been permanently excluded',
  'onboarding.login.error_suspended_kyc':
    'We are unable to verify your identity. Please contact customer service to continue',
  'onboarding.login.error_temporary_exclusion':
    'Sorry... Your account has been locked until DATE',
  'onboarding.login.footerForgotInfo': 'Need an account? <link>Join now</link>',
  'onboarding.login.forgotpassword': '忘记密码',
  'onboarding.login.header': 'Welcome Back',
  'onboarding.login.joinNowCTA': '立即加入',
  'onboarding.login.notsignedin': 'You are not signed in.',
  'onboarding.login.pagetitle': '| 登录',
  'onboarding.login.signup': "Don't have an account? <cta>Join Now</cta>",
  'onboarding.login.signupcta': '立即加入',
  'onboarding.login.subtitle':
    "The ultimate destination for racing and sports betting. Let's sign you back in so you can <b>start placing bets now!</b>",
  'onboarding.login.title': 'Welcome back!',
  'onboarding.refreshpage': '刷新页面，或者稍后再试。',
  'onboarding.register.verification': 'Verify Your Account',
  'onboarding.signupErrorMessages.betstopDescription':
    'As you are currently registered on the <betstop>BetStop</betstop> national register you are unable to open a new interactive wagering services account.n Find out more about services that can assist with <gamblingHelpOnline>your gambling here</gamblingHelpOnline>.  Gambling Help is available to you 24/7. Please call <phone>1800 858 858</phone> or visit <gamblingHelpOnline>https://www.gamblinghelponline.org.au</gamblingHelpOnline>. Confidential, professional, free help, 24 hours a day, 7 days a week. Talk to someone who understands your issues.',
  'onboarding.signupErrorMessages.betstopTitle': 'Betsop',
  'onboarding.signuperrormessages.addresslookuppartial':
    'An error occurred during address lookup, please fill in the remaining details.',
  'onboarding.signuperrormessages.contactcustomerservice':
    'Error: Contact Customer Service',
  'onboarding.signuperrormessages.emailexists':
    'This email address is already in use.',
  'onboarding.signuperrormessages.streetnumberrequired':
    'Please enter an address that contains a street number.',
  'onboarding.step1.ageacknowledgementerror':
    'Sorry, you need to agree before you can create an account',
  'onboarding.step1.emailinputerror': 'Email requirements not met',
  'onboarding.step1.emailinputplaceholder': 'eg. john@email.com',
  'onboarding.step1.header': 'Welcome, Let’s get you set up!',
  'onboarding.step1.pageSubtitle':
    'PunterBet, the ultimate destination for racing and sports betting. Create an account and start placing bets now!',
  'onboarding.step1.pageTitle': "Let's get you started.",
  'onboarding.step1.passwordempty': 'A password is needed',
  'onboarding.step1.passwordinputerror': 'Password requirements not met',
  'onboarding.step1.passwordinputlabel': '密码',
  'onboarding.step1.passwordinputplaceholder': '••••••••',
  'onboarding.step1.passwordnospaces': 'Password cannot contain any spaces',
  'onboarding.step1.passwordrule1': '包含小写和大写字母',
  'onboarding.step1.passwordrule2': '至少包含 1 个数字',
  'onboarding.step1.passwordrule3': '密码长度超过 8 个字符',
  'onboarding.step1.passwordrule4': '密码不可包含空格',
  'onboarding.step1.subheader': 'Please enter your details.',
  'onboarding.step1.tabTitle': '| 报名',
  'onboarding.step1.welcome': 'Welcome to {getThemeName}',
  'onboarding.step2.addressinputlabel': '地址',
  'onboarding.step2.addressinputmanualplaceholder': 'Manual Entry',
  'onboarding.step2.addressinputplaceholder': '* Address must match your ID',
  'onboarding.step2.addressrequirederrortext':
    'Residential Address is required',
  'onboarding.step2.button': 'Get Verified',
  'onboarding.step2.dobinputerror':
    'Sorry, you need to be over 18 years of age to use this platform',
  'onboarding.step2.dobrequirederrortext': 'Date of Birth is required',
  'onboarding.step2.fieldTooLongErrorText': 'Field is too long',
  'onboarding.step2.firstnameerrortext': 'First Name is required',
  'onboarding.step2.firstnameinputlabel': '名',
  'onboarding.step2.header': "Let's get you verified!",
  'onboarding.step2.lastnameerrortext': 'Last Name is required',
  'onboarding.step2.lastnameinputlabel': '姓',
  'onboarding.step2.middleNameInputLabel': '中间名',
  'onboarding.step2.middleNameInputPlaceholder': '选填',
  'onboarding.step2.mobileinputlabel': '手机',
  'onboarding.step2.mobilenumberauonlyerror':
    'Must be an Australian mobile number.',
  'onboarding.step2.mobilenumberonlyerror':
    'Mobile field can only contain numbers',
  'onboarding.step2.mobileplaceholder': 'eg. 0412345678',
  'onboarding.step2.mobilerequirederrortext': 'Mobile is required',
  'onboarding.step2.pagetitle': '| Account Verification',
  'onboarding.step2.postcodeinputlabel': 'Postcode',
  'onboarding.step2.postcodelengtherror': 'Postcode must be 4 digits',
  'onboarding.step2.postcoderequirederror': 'Postcode is required',
  'onboarding.step2.skipverificationoption':
    'Please skip for now and manually verify me',
  'onboarding.step2.stateinputlabel': '州/省',
  'onboarding.step2.staterequirederror': 'State is required',
  'onboarding.step2.streetnameinputlabel': '街道名称',
  'onboarding.step2.streetnamerequirederror': 'Street name is required',
  'onboarding.step2.streetnumberinputlabel': '街道号码',
  'onboarding.step2.streetnumberrequirederror': 'Street number is required',
  'onboarding.step2.subheader':
    'This info will allow us to make sure you are a real person and lets us check that you are OK to start betting with us.',
  'onboarding.step2.suburbinputlabel': '区/县',
  'onboarding.step2.suburbrequirederror': 'Suburb is required',
  'onboarding.step2.titleoptions.0': 'Mr',
  'onboarding.step2.titleoptions.1': 'Mrs',
  'onboarding.step2.titleoptions.2': 'Miss',
  'onboarding.step2.titleoptions.3': 'Ms',
  'onboarding.step2.titleoptions.4': 'Dr',
  'onboarding.step2.titleoptions.5': 'Other',
  'onboarding.step2.validMiddleNameRequiredErrorText':
    'Valid middle name is required',
  'onboarding.step2.validnamerequirederrortext': 'Valid name is required',
  'onboarding.step2.verificationerror': 'There was an error verifying you',
  'onboarding.step2.verificationerrortext':
    "Sorry, we couldn't verify you. Please try again later.",
  'onboarding.step3.button': '继续',
  'onboarding.step3.depositlimiterror':
    'There was an error creating your deposit limit',
  'onboarding.step3.header': 'Congrats! You are ready to go',
  'onboarding.step3.limitamountinputlabel': '限制金额',
  'onboarding.step3.limitamountrequiredtext':
    'As you have chosen to add a deposit limit, your limit amount is required',
  'onboarding.step3.limitdurationrequiredtext':
    'As you have chosen to add a deposit limit, your limit duration is required',
  'onboarding.step3.limitnumbersonlyerror':
    'Deposit limit can only contain numbers',
  'onboarding.step3.limitperiodinputlabel': '限额时长',
  'onboarding.step3.limitperiodoptions.0': '1 天',
  'onboarding.step3.limitperiodoptions.1': '7 天',
  'onboarding.step3.limitperiodoptions.2': '14 天或',
  'onboarding.step3.limitperiodoptions.3': '28 天的',
  'onboarding.step3.radiooption1':
    'No, I have read and understand the benefits and do not want to set a Deposit Limit',
  'onboarding.step3.radiooption2': 'Yes, I would like to set a Deposit Limit',
  'onboarding.step3.subheader': 'Would you like to set up a deposit limit?',
  'qam.balances.btn': '余额',
  'qam.getVerified.btn': 'Get verified',
  'qam.getVerified.desc':
    'Your account <underline>must</underline> be verified to make withdrawals.',
  'qam.quickDeposit.btnCard': 'Add a card',
  'qam.quickDeposit.cancel': '取消',
  'qam.quickDeposit.completed.footer': 'Closing in <timer></timer> seconds...',
  'qam.quickDeposit.confirm': '确认',
  'qam.quickDeposit.confirm.msg': 'Add $<amount></amount> to your account?',
  'qam.quickDeposit.desc': 'Quick Deposit',
  'qam.quickDeposit.failed': 'Payment unsuccessful',
  'qam.quickDeposit.failed.desc':
    'Please check your payment information and try again.',
  'qam.quickDeposit.footer.addCard':
    'To make a Quick Deposit, <underline>add a card</underline> to your account.',
  'qam.quickDeposit.footer.chargeCard':
    'By placing a Quick Deposit, we will charge card (****<maskedcard></maskedcard>) immediately.',
  'qam.quickDeposit.otherAmount': '其他',
  'qam.quickDeposit.processing': 'Requesting payment...',
  'qam.quickDeposit.processing.footer': 'This might take a moment or two...',
  'qam.quickDeposit.successful': 'Payment successful',
  'racing.errormessages.getotherracesbyvenuefailmessage':
    "Couldn't load other races for this venue",
  'racing.errormessages.getracemarketsfailmessage':
    "Couldn't load race markets",
  'racing.errormessages.getracemetafailmessage': "Couldn't load race meta data",
  'racing.errormessages.getraceresultsfailmessage':
    "Couldn't load race results",
  'racing.errormessages.getracerunnerlistfailmessage':
    "Couldn't load race runner list",
  'racing.errormessages.getracingvenuelistfailmessage': "Couldn't load venues",
  'racing.errormessages.racetypeavailable':
    'No <types>type</types> available at this moment',
  'racing.evenShot.UnavailableTimeTitleBackup':
    'Sorry, Even Shot is available closer to race start time.',
  'racing.evenShot.betPlaced.heading':
    'You have already placed a bet for this race.',
  'racing.evenShot.betPlaced.subHeading':
    'Return to this page once the race has ended to see if you have won.',
  'racing.evenShot.heading': 'Even Shot',
  'racing.evenShot.slogan':
    'Get straight to the heart of the action with one, even money chance.',
  'racing.evenShot.top': 'Even Shot - Top',
  'racing.evenShot.top1': '获胜',
  'racing.evenShot.top2': 'Top 2',
  'racing.evenShot.top3': 'Top 3',
  'racing.evenShot.top4': 'Top 4',
  'racing.evenShot.win': 'Even Shot - Win',
  'racing.exotics.addtobetslip': 'Add to Bet Slip',
  'racing.exotics.bettype': 'Bet Type',
  'racing.exotics.boxed': '合票',
  'racing.exotics.clearselection': 'Clear Selection',
  'racing.exotics.combos': '组合',
  'racing.exotics.dividend': 'Dividend',
  'racing.exotics.flexi': 'Flexi',
  'racing.exotics.raceresults': 'Race Results',
  'racing.exotics.selectfield': 'Select Field',
  'racing.generic.addToBetSlip': 'Add to Bet Slip',
  'racing.generic.betAwaitingApproval': 'Bet Awating Approval',
  'racing.generic.betPlaced': 'Bet Placed',
  'racing.generic.clearSelections': 'Clear Selection',
  'racing.generic.odds': 'Odds',
  'racing.generic.place': 'Place',
  'racing.generic.placeMD': '排名 MD',
  'racing.generic.winBT': '奖金 BT',
  'racing.generic.winMD': '奖金 MD',
  'racing.mysteryBet.error':
    'Sorry, Mystery Bet is not currently available at this price on this race',
  'racing.mysteryBet.info':
    'Select from 2.00, 4.00 or 8.00 odds and reveal your mystery single proposition in the Betslip.',
  'racing.mysteryBet.mysteryBetRolloverInfo':
    ' If your bet wins, your winning funds will rollover to place another Mystery Bet at the same odds on the next available race.',
  'racing.mysteryBet.wantRollover': 'Want to rollover?',
  'racing.mysteryBet.yourSelection': 'Your Selection: ',
  'racing.raceDetails.comeBackLater': 'Please come back later.',
  'racing.raceDetails.evenShotNotAvailable':
    'Sorry, Even Shot is not currently available for this race.',
  'racing.raceDetails.evenShotTime':
    'Sorry, Even Shot is available {time} minutes from the race start time.',
  'racing.raceDetails.selectAnotherRace': 'Please select another race.',
  'racing.raceDetails.winTabInfo':
    'Back a runner to Win or Place across Fixed Odds (FO) or TOTE markets. TOTE markets offer either Middle Dividend (MD) or Best TOTE (BT) odds.',
  'racing.raceResults.eventRules.twoPlaceDividends': 'No Third Dividend',
  'racing.raceRunnerItem.scratched': 'SCRATCHED',
  'racing.raceRunnerItem.suspended': 'SUS',
  'racing.racedetails.eventrules.noplace':
    'No place betting available on this race',
  'racing.racedetails.eventrules.ruleheading': 'Event Rules: ',
  'racing.racedetails.eventrules.threeplacedividends':
    'Three place dividends paid',
  'racing.racedetails.markettabs.raceresults': '取胜/名次',
  'racing.racedetails.markettabs.winplace': '取胜/名次',
  'racing.racedetails.moneyBack': 'Money Back',
  'racing.racedetails.pagetitle': '| Race Details',
  'racing.racedetails.racecardheading': 'Race Card',
  'racing.racedetails.racestatus': '{status}',
  'racing.racedetails.resultedstatus': 'Resulted',
  'racing.racedetails.resultstabs.results': 'Results',
  'racing.racemeetings.abandoned': 'ABND',
  'racing.racemeetings.closed': 'CLSD',
  'racing.racemeetings.greys': 'Greys',
  'racing.racemeetings.harness': 'Harness',
  'racing.racemeetings.horses': 'Horses',
  'racing.racemeetings.noraces': 'No Races',
  'racing.racemeetings.pagetitle': '| Race Meetings',
  'racing.raceresults.exotics.firstfour': 'First Four',
  'racing.raceresults.place': 'Place',
  'racing.raceresults.positions.0': '1st',
  'racing.raceresults.positions.1': '2nd',
  'racing.raceresults.positions.2': '3rd',
  'racing.raceresults.positions.3': '4th',
  'racing.raceresults.raceresults': 'Race Results',
  'racing.raceresults.win': '奖金',
  'racing.srm.hideSelections': 'Hide Selection',
  'racing.srm.top': 'Top {number}',
  'racing.srm.viewSelections': 'View Selection',
  'racing.srm.win': '奖金',
  'sidenav.allsports': 'All Sports',
  'sidenav.depositlimits': 'Deposit Limits',
  'sidenav.join': '加入',
  'sidenav.login': '登录',
  'sidenav.logout': '登出',
  'sidenav.nexttojump': '即将开赛',
  'sidenav.racing': '竞速',
  'sidenav.support': '支持 - ',
  'sidenav.topEvents': 'Top Events',
  'sidenav.withdraw': 'Withdraw Funds',
  'sports.allsports.azheading': '体育',
  'sports.allsports.sportslisttitle': 'Sports A-Z',
  'sports.allsports.topsports': 'Top Sports',
  'sports.competitionsBySport.all': '全部 {name}',
  'sports.competitionsBySport.allLeagues': 'All Leagues',
  'sports.competitionsBySport.events': 'Events',
  'sports.competitionsBySport.schedule': 'Schedule',
  'sports.competitionsbysport.allcompetitionstitle': '全部',
  'sports.competitionsbysport.featuredcompetitionstitle': '精选',
  'sports.errormessages.getcompetitionsfailmessage':
    "Couldn't load competitions for this sport",
  'sports.errormessages.getmarketsfailmessage':
    "Couldn't load markets for this match",
  'sports.errormessages.getmatchesfailmessage':
    "Couldn't load matches for this competition",
  'sports.events.noPropositons': 'N/A',
  'sports.marketsbymatch.matchclosed':
    'Match {match} has now closed, have a punt on a different game!',
  'sports.marketsbymatch.matchclosedTitle': 'Match closed',
  'sports.marketsbymatch.nomarkets':
    'There are no markets for this event. Please check the {sport} page for other active markets.',
  'sports.marketsbymatch.nomarketsbutton': 'Go to {sport}',
  'sports.marketsbymatch.okaybuttontext': 'Okay',
  'sports.marketsbymatch.pagetitlefallback': 'Markets',
  'sports.matchDetailPage.addToBetSlip': 'Add to Bet Slip',
  'sports.matchDetailPage.clearAll': 'Clear All',
  'sports.matchDetailPage.clearSelections': 'Clear Selections',
  'sports.matchDetailPage.clearSelectionsPrompt':
    'Are you sure you want to clear all of your current selections?',
  'sports.matchDetailPage.hideSelections': 'Hide selections',
  'sports.matchDetailPage.legs': 'Legs <strong>{legs}</strong>',
  'sports.matchDetailPage.maxSelectionsError':
    'A Multi Bet must not exceed 20 legs.',
  'sports.matchDetailPage.odds': `{hasOdds, select, true {Odds <strong>{odds}</strong>} other {Odds <strong>N/A</strong>}}`,
  'sports.matchDetailPage.selectionError': 'This selection cannot be combined.',
  'sports.matchDetailPage.viewSelections': 'View selections',
  'sports.matchcard.versus': 'VS',
  'sports.propositions.seeless': 'See less',
  'sports.propositions.seemore': 'See more',
  'sports.tabs.events': 'Events',
  'sports.tabs.futures': 'Futures',
  'sports.tabs.schedule': 'Schedule',
  'sports.upcoming.noPropositons': 'Propositions unavailable.',
  'onracebet.headertext': '我对这场比赛的投注',
  'srm.clearSelections': '清除',
};

type KeysProps = keyof typeof zh;
export type ZhKeysProps = Partial<{ [K in KeysProps]: string }>;
